/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { DescargaRespuesta } from './../_models/descargas';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class DescargaService {
    constructor(private http: HttpClient) { }

    getAll(file: string) {
        return this.http.get<DescargaRespuesta>('assets/db/' + file + '.json');
    }

}
